import { render, staticRenderFns } from "./DuplicateContract.vue?vue&type=template&id=065ecae2&scoped=true"
import script from "./DuplicateContract.vue?vue&type=script&lang=js"
export * from "./DuplicateContract.vue?vue&type=script&lang=js"
import style0 from "./DuplicateContract.vue?vue&type=style&index=0&id=065ecae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ecae2",
  null
  
)

export default component.exports